
















































import { Vue, Component, Prop } from 'vue-property-decorator'
import VueI18n from 'vue-i18n'

import AppStoreModule from '@revas/kadra-library/src/core/app/vue/vuex/AppStoreModule'

import { GlobalLayout, LinearLayout, BaseOverlay, BaseHeading, BaseAnchor, BaseNotification, BaseText, NotificationsLayout } from '@revas/reef'

import AppMessage from '@revas/kadra-library/src/core/app/vue/vuex/AppMessage'
import OnboardingStoreModule from '@revas/kadra-library/src/revas/vue/vuex/OnboardingStoreModule'
import { SystemInfo } from '@/models'

@Component({
  components: {
    GlobalLayout,
    LinearLayout,
    BaseOverlay,
    BaseHeading,
    BaseNotification,
    BaseAnchor,
    BaseText,
    NotificationsLayout
  }
})
export default class App extends Vue {
  @Prop() readonly appStoreModule!: AppStoreModule
  @Prop() readonly onboardingStoreModule!: OnboardingStoreModule
  @Prop() readonly i18n!: VueI18n
  @Prop() readonly systemInfo!: SystemInfo

  get isPanic () {
    return this.appStoreModule.isPanic
  }

  get panicData () {
    return this.appStoreModule.panic
  }

  get isWaiting () {
    return this.appStoreModule.isWaiting
  }

  get messages () {
    return this.appStoreModule.messages
  }

  disposeMessage (message: AppMessage) {
    this.appStoreModule.asyncDisposeMessage(message)
  }

  get hasRequiredAction () {
    return this.requiredAction !== null
  }

  get requiredAction () {
    if (this.onboardingStoreModule === null || this.onboardingStoreModule === undefined) {
      return {}
    }
    return this.onboardingStoreModule.requiredAction
  }

  get mailTo () {
    return `mailto:${this.systemInfo.adminEmail}`
  }
}
